var _MemoryCache_internalCache;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import KeyNotFoundException from '../Exceptions/KeyNotFoundException';
import KeyAlreadyDefinedException from '../Exceptions/KeyAlreadyDefinedException';
import AsyncCacheItem from './AsyncCacheItem';
import { isUndefinedOrNull } from '../TypeHelpers';
/**
 * Creates an in-memory cache. This cache will be forgotten on disposal.
 */
export default class MemoryCache {
    constructor() {
        _MemoryCache_internalCache.set(this, void 0);
        __classPrivateFieldSet(this, _MemoryCache_internalCache, new Map(), "f");
    }
    add(key, value, expiryPolicy) {
        if (__classPrivateFieldGet(this, _MemoryCache_internalCache, "f").has(key)) {
            throw new KeyAlreadyDefinedException(key);
        }
        __classPrivateFieldGet(this, _MemoryCache_internalCache, "f").set(key, new AsyncCacheItem(value, expiryPolicy));
    }
    async addOrGetAsync(key, factory, expiryPolicy) {
        const cacheItem = __classPrivateFieldGet(this, _MemoryCache_internalCache, "f").get(key);
        const value = await (cacheItem === null || cacheItem === void 0 ? void 0 : cacheItem.getValueAsync());
        if (!isUndefinedOrNull(value)) {
            return value;
        }
        else {
            const value = factory(key);
            __classPrivateFieldGet(this, _MemoryCache_internalCache, "f").set(key, new AsyncCacheItem(value, expiryPolicy));
            return await value;
        }
    }
    addOrReplace(key, value, expiryPolicy) {
        __classPrivateFieldGet(this, _MemoryCache_internalCache, "f").set(key, new AsyncCacheItem(value, expiryPolicy));
    }
    async cleanAsync() {
        for (const item of __classPrivateFieldGet(this, _MemoryCache_internalCache, "f")) {
            const value = item[1];
            const key = item[0];
            if (!isUndefinedOrNull(await value.getValueAsync())) {
                __classPrivateFieldGet(this, _MemoryCache_internalCache, "f").delete(key);
            }
        }
    }
    async getAsync(key) {
        const cacheItem = __classPrivateFieldGet(this, _MemoryCache_internalCache, "f").get(key);
        if (isUndefinedOrNull(cacheItem)) {
            throw new KeyNotFoundException(key);
        }
        const value = await cacheItem.getValueAsync();
        if (isUndefinedOrNull(value)) {
            __classPrivateFieldGet(this, _MemoryCache_internalCache, "f").delete(key);
            throw new KeyNotFoundException(key);
        }
        return value;
    }
    async tryGetAsync(key) {
        const cacheItem = __classPrivateFieldGet(this, _MemoryCache_internalCache, "f").get(key);
        if (cacheItem === undefined) {
            return { success: false };
        }
        const value = await cacheItem.getValueAsync();
        if (isUndefinedOrNull(value)) {
            __classPrivateFieldGet(this, _MemoryCache_internalCache, "f").delete(key);
            return { success: false };
        }
        return { success: true, value };
    }
    replace(key, value, expiryPolicy) {
        if (!__classPrivateFieldGet(this, _MemoryCache_internalCache, "f").has(key)) {
            throw new KeyNotFoundException(key);
        }
        __classPrivateFieldGet(this, _MemoryCache_internalCache, "f").set(key, new AsyncCacheItem(value, expiryPolicy));
    }
}
_MemoryCache_internalCache = new WeakMap();
